<template>
  <div v-if="surveys && surveys.length">
    <survey-modal
      v-if="selectedSurvey"
      :survey="selectedSurvey"
      :logo="logoUrl"
      @cancel="cancelModal"
      @complete="completedSurvey"
    />
    <surveys-notification
      v-if="showNotifications"
      :surveys="surveys"
      @dismiss-notifications="showNotifications = false"
      @select-survey="selectSurvey"
    />
  </div>
</template>

<script>
import SurveysNotification from '../components/Notifications'
import SurveyModal from '../components/Modal'

  export default {
    name: 'surveys',
    components: {
      SurveysNotification,
      SurveyModal
    },
    props: {
      userId: {
        type: String,
        required: true
      },
      clientId: {
        type: String,
        required: true
      }
    },
    data: () => ({
      showNotifications: false,
      selectedSurvey: null,
      surveys: [],
      logoUrl: null
    }),
    watch: {
      surveys: function (s) {
        if (s.length) this.showNotifications = true
      }
    },
    methods: {
      async getUserSurveys () {
        if (!this.userId || !this.clientId) return

        try {
          const { data } = await axios.get(`https://eymbhklhck.execute-api.eu-west-2.amazonaws.com/production/surveys`, {
            params: {
              userSurveys: true,
              userId: this.userId,
              clientId: this.clientId
            }
          })
          this.surveys = data.data
        } catch (error) {
          throw error
        }
      },
      async getClientsLogo () {
        if (!this.clientId) return
        try {
          const { data } = await axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/get-logo`, { params: { clientId: this.clientId }})
          this.logoUrl = data.url
        } catch (error) {
          throw error
        }
      },
      selectSurvey (id) {
        this.showNotifications = false
        this.selectedSurvey = this.surveys.filter(s => s.s_id === id)[0]
      },
      async completedSurvey () {
        await this.getUserSurveys()
        this.selectedSurvey = null
      },
      async cancelModal () {
        await this.getUserSurveys()
        this.selectedSurvey = null
        this.showNotifications = true
      }
    },
    async mounted () {
      await Promise.all([
        this.getUserSurveys(),
        this.getClientsLogo()
      ])
    }
  }
</script>

<style lang="scss" scoped>

  @import '../scss/date-picker';

</style>